<template>
  <div class="container">
    <el-row>
      <el-col :span="2">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="22">
        <p style="text-align: center;font-size: 28px">2、检测综述</p>
        <table>
          <tr>
            <td colspan="4" style="text-align: center;font-size: 20px">不符合要求项数量</td>
          </tr>
          <tr>
            <td>火灾危险性</td>
            <td>关键项目A</td>
            <td>关键项目B</td>
            <td>关键项目C</td>
          </tr>
          <template v-for="(item,i) in items">
            <tr :key="i">
              <td>{{ item.item }}</td>
              <td>{{ item.A }}</td>
              <td>{{ item.B }}</td>
              <td>{{ item.C }}</td>
            </tr>
          </template>

        </table>
        <table style="margin-top: 20px">
          <tr>
            <td style="text-align: center;font-size: 20px;">检测结果汇总及整改建议</td>
          </tr>
          <tr>
            <td>
              <el-input type="textarea" :rows="30" placeholder="请输入内容" v-model="form.jczs"></el-input>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      rr_type: 'report',
      items: ['电气系统的带电设备红外诊断'],
      form: {
        jczs: ''
      }
    }
  },
  methods: {
    async getBelows() {
      try {
        let res = await this.$Api.post('get_report_cma_belows', {
          project_id: this.project_id,
          site_id: this.site_id
        })
        if (res) {
          this.items = res
        }
      } catch (e) {
        this.$message.error((e.errormsg))
      }
    },
    async getJczs() {
      try {
        let res = await this.$Api.post('get_record_cma_jczs', {
          project_id: this.project_id,
          site_id: this.site_id
        })
        if (res) {
          this.form = res
        }
      } catch (e) {
        this.$message.error((e.errormsg))
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.getBelows()
    this.getJczs()
  }
}
</script>
<style scoped>
table {
  width: 88%;
  margin-left: 50px;
}

p {
  text-align: center;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
}
</style>
